import React, { useEffect, useState} from 'react';
import MenuIcon from '@mui/icons-material/Menu';
import {Box,Typography,Container,Button, Divider, IconButton} from '@mui/material'
import CircularProgress from '@mui/material/CircularProgress';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import {useSelector, useDispatch} from 'react-redux';
import {useTheme} from '@mui/material/styles'
import { DeleteForever, Remove} from '@mui/icons-material';


const ListDialog = ({visible,setVisible,data,setData,deleting})=>{

	const theme = useTheme()
	const user = useSelector(state => state?.auth.user);
	const [select,setSelect] = useState(0)
    const [del, setDel] = useState(false);

	const onClose = () => {
		setVisible(false);
	};

return(    
	<Dialog open={visible} onClose={onClose} sx={{borderRadius:10,justifyContent:"center",textAlign:"center"}}>
		<DialogTitle sx={{background:theme.palette.background.default}}> 
			<Box width="90%" display="flex" flexDirection="row" justifyContent="space-between" alignContent="center">
				<Box display="flex" flexDirection="row">
					<IconButton sx={{marginTop:3}}>
						<MenuIcon/>
					</IconButton>					
					<Typography mr={2} mt={4} style={{fontSize:15,fontWeight:400,fontFamily:"dinofans"}}>
						Destinations
					</Typography>	
				</Box>
				<IconButton onClick={(e)=>{
					setData([])
				}} sx={{marginTop:3}}>
					<DeleteForever sx={{color:"red"}}/>
				</IconButton>
			</Box>
		</DialogTitle>
		<DialogContent m={theme.spacing(1)} sx={{height:800,width:{xs:300,md:400},justifyContent:"center",background:theme.palette.background.default}}>
			 {
				data?.length == 0 && (
					<Box>
						<Typography m={1} style={{fontSize:15,fontWeight:400,color:"gold"}}>
							Destination list is empty
						</Typography>
					</Box>
				)
			 }
			{
				data?.map((item,index)=>{
					return(
						<Box m={1} key={index}>
							<Box sx={{ display:"flex",flexDirection:"row",justifyContent:"space-between",alignItems:"flex-start",width:"95%",mb:1}}>
							    <Typography  mt={1} style={{fontSize:15,fontWeight:400}}>
									# {index+1}
								</Typography>
								<Box textAlign="center" >
									<Typography sx={{fontSize:11,fontWeight:400,color:"gold",fontFamily:"dinofans",mt:1}}>
                                        {item?.email}
									</Typography>									
								</Box>
								<IconButton onClick={async(e)=>{
									e?.preventDefault()
                                    setSelect(index)
                                    setDel(true)
                                    setData(data?.filter(itm=>itm?.email !== item?.email))
									// handleUserDelete(item?.email)
								}} sx={{background:"#fff",borderRadius:3}}>
									{
										(del && select == index) ?
											<CircularProgress size={15} sx={{color:"#ff0"}}/>
										:
											<Remove fontSize="small" sx={{color:"#000"}}/>
									}
								</IconButton>								
							</Box>
                            <Divider/>
						</Box>
					)
				})
			}
		</DialogContent>
	</Dialog>
	)
}

export default ListDialog;